<template>
  <div>
    <el-table :data="tableData" border style="width: 100%">
      <el-table-column label="编号" align="center">
        <template slot-scope="scope">{{
          scope.$index + 1 > 9 ? scope.$index + 1 : "0" + (scope.$index + 1)
        }}</template>
      </el-table-column>
      <el-table-column prop="Name" label="姓名" align="center">
      </el-table-column>
      <el-table-column prop="GradeName" label="年级" align="center">
      </el-table-column>
      <el-table-column prop="ClassName" label="班级" align="center">
      </el-table-column>
      <el-table-column prop="Time" label="时间" align="center" width="200">
      </el-table-column>
      <el-table-column label="咨询议题" align="center">
        <template slot-scope="scope">
          <el-tooltip
            class="item"
            effect="dark"
            :content="scope.row.Title"
            placement="top-start"
          >
            <div class="textOver">{{ scope.row.Title }}</div>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="咨询目的" align="center">
        <template slot-scope="scope">
          <el-tooltip
            class="item"
            effect="dark"
            :content="scope.row.Objective"
            placement="top-start"
          >
            <div class="textOver">{{ scope.row.Objective }}</div>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="咨询经历" align="center">
        <template slot-scope="scope">
          <el-tooltip
            class="item"
            effect="dark"
            :content="scope.row.Content"
            placement="top-start"
          >
            <div class="textOver">{{ scope.row.Content }}</div>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column
        prop="CreateTime"
        label="申请时间"
        align="center"
        width="200"
      >
      </el-table-column>
      <el-table-column prop="Status" label="状态" align="center">
      </el-table-column>
      <!-- <el-table-column label="标记" align="center">
        <template slot-scope="scope" v-if="scope.row.ButtonType == 2">
          <el-button type="warning" @click="onClickButton(scope.row)">{{
            scope.row.ButtonType == 2 ? "标记" : ""
          }}</el-button>
        </template>
      </el-table-column> -->
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.Status != '已取消'"
            :type="scope.row.ButtonType == 1 ? 'primary' : 'warning'"
            @click="onClickButton(scope.row)"
            >{{ scope.row.ButtonType == 1 ? "审批" : "标记" }}</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      layout="prev, pager, next"
      @current-change="handleCurrentChange"
      :page-size="PageSize"
      :total="total"
      style="float: right"
    ></el-pagination>
    <!-- 审批 -->
    <el-dialog title="预约审批" :visible.sync="dialogVisible" width="50%">
      <div>
        <el-descriptions class="margin-top" :column="3" border>
          <el-descriptions-item>
            <template slot="label"> 姓名 </template>
            {{ itemInfo.Name }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label"> 年级 </template>
            {{ itemInfo.GradeName }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label"> 班级 </template>
            {{ itemInfo.ClassName }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label"> 时间 </template>
            {{ itemInfo.Time }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label"> 咨询议题 </template>
            {{ itemInfo.Title }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label"> 咨询目的 </template>
            {{ itemInfo.Objective }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label"> 咨询经历 </template>
            {{ itemInfo.Content }}
          </el-descriptions-item>
        </el-descriptions>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onClickSuccess(1)" type="primary">{{
          itemInfo.ButtonType == 1 ? "同 意" : "标记完成"
        }}</el-button>
        <el-button @click="onClickSuccess(2)">{{
          itemInfo.ButtonType == 1 ? "拒 绝" : "标记爽约"
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  GetWebStudentOnlineList,
  ApprovalOnlineInfo,
  SignOnlineInfo,
} from "../../api/api";

export default {
  data() {
    return {
      tableData: [],
      userInfo: {},
      PageIndex: 1,
      PageSize: 10,
      total: 0,
      dialogVisible: false,
      itemInfo: {},
    };
  },
  created() {
    this.userInfo = JSON.parse(
      window.localStorage.user ? window.localStorage.user : null
    );
    this.GetWebStudentOnlineList();
  },
  methods: {
    // 同意/标记完成
    async onClickSuccess(status) {
      if (this.itemInfo.ButtonType == 1) {
        let res = await ApprovalOnlineInfo({
          id: this.itemInfo.Id,
          status: status,
        });
        if (res.data.success) {
          this.$message({
            type: "success",
            message: "成功！",
          });
          this.GetWebStudentOnlineList();
          this.dialogVisible = false;
        } else {
          this.$message({
            type: "error",
            message: res.data.msg,
          });
        }
      } else {
        let xhr = await SignOnlineInfo({
          id: this.itemInfo.Id,
          status: status,
        });
        if (xhr.data.success) {
          this.$message({
            type: "success",
            message: "成功！",
          });
          this.GetWebStudentOnlineList();
          this.dialogVisible = false;
        } else {
          this.$message({
            type: "error",
            message: xhr.data.msg,
          });
        }
      }
    },
    async onClickButton(item) {
      this.itemInfo = item;
      this.dialogVisible = true;
    },
    async GetWebStudentOnlineList() {
      let res = await GetWebStudentOnlineList({
        SysUserId: this.userInfo.uID,
        PageIndex: this.PageIndex,
        PageSize: this.PageSize,
      });
      if (res.data.success) {
        this.total = res.data.response.dataCount;
        this.tableData = res.data.response.data;
      } else {
        this.total = 0;
        this.tableData = [];
      }
    },
    handleCurrentChange(val) {
      this.PageIndex = val;
      this.GetWebStudentOnlineList();
    },
  },
};
</script>
<style>
.textOver {
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}
</style>